import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  editImagePage: {
    height: '100%',
    display: 'flex',
  },
  navigationView: {
    backgroundColor: '#FFFFFF',
    width: '85px',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: '32px',
  },
  navigationPlaceholder: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '85px',
    height: '32px',
    backgroundColor: '#FFFFFF',
    zIndex: -1,
  },
  contentWrapper: {
    height: '100%',
    backgroundColor: '#F0F0F0',
    paddingLeft: '12px',
    paddingTop: '12px',
    marginLeft: '85px',
    ...shorthands.flex(1, 1, '0px'),
  },
});
